import { render } from "./JFcirculation.vue?vue&type=template&id=8b8dad16&scoped=true"
import script from "./JFcirculation.vue?vue&type=script&lang=js"
export * from "./JFcirculation.vue?vue&type=script&lang=js"

import "./JFcirculation.vue?vue&type=style&index=0&id=8b8dad16&lang=scss&scoped=true"
import "./JFcirculation.vue?vue&type=style&index=1&id=8b8dad16&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mac\\Downloads\\PCguanli\\zhongtaiworkPC\\yungong_1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b8dad16"]])

export default __exports__